<template>
  <div class="home">
    <div style="height: 72px;">
      <div class="top">
        <!-- <div class="juanli-box flex flex-ac flex-jsb">
          <div class="you-box flex flex-ac">
            <div v-if="1 === 2" class="nav-itme flex flex-ac">
              <i class="iconfont icon-qiandao"></i>
              <a href="/#/index/task-center">新人签到</a>
            </div>
            <div class="nav-itme flex flex-ac" @click="goPage('this','/me/inform')">
              <i class="iconfont icon-xx"></i>
              <span v-if="loginInfo.message_notice_num&&loginInfo.message_notice_num!=0" class="label-n">{{ loginInfo.message_notice_num>99?'99+':loginInfo.message_notice_num }}</span>
              <a href="/#/me/inform">消息通知</a>
            </div>
            <div v-if="1 === 2" class="nav-itme flex flex-ac">
              <i class="iconfont icon-spbk"></i>
              <span>饰品百科</span>
            </div>
          </div>
        </div> -->
        <el-row class="top-el-row flex flex-ac">
          <div class="top-l-r flex flex-jsb">
            <el-col :span="16" class="logo flex flex-ac logo1">
              <img src="@/assets/img/menu1.png" class="yidong-menu" @click="showNav=!showNav" style="height: 40px;" />
              <img class="img1 logo-pc" src="@/assets/images/logo-img.png" @click="goPage('this','/index')" />
              <img class="img1 logo-mobile" src="@/assets/images/h5.png" @click="goPage('this','/index')" />
              <img class="img1 logo-pad" src="@/assets/images/app.png" @click="goPage('this','/index')" />
              <!-- <a href="/" v-if="!showMenuState" class="logo-word">PlaySkins</a> -->
              <!-- 顶部导航 -->
              <div class="base-header" v-if="showNav" v-clickoutside="clickOut">
                <div class="nav2">
                  <ul>
                    <li :class="item.selState ? 'active' : ''" v-for="(item, index) in menu" :key="index" @click="goMenu(item.id, item.path)">
                      <span>{{item.value}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </el-col>
            <el-col :span="8" class="top-name flex-ac flex">
              <div class="flex flex-ac" style="margin-right: 10px;">
                <svg id="wifi" fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg" class="WifiIcon_wifi_TvIYK">
                  <path clip-rule="evenodd" d="M0 6.42857C0 5.83684 0.479695 5.35714 1.07143 5.35714C2.19704 5.35714 3.31164 5.57885 4.35157 6.0096C5.39151 6.44036 6.33641 7.07172 7.13234 7.86766C7.92827 8.66359 8.55964 9.60849 8.9904 10.6484C9.42115 11.6884 9.64286 12.803 9.64286 13.9286C9.64286 14.5203 9.16316 15 8.57143 15C7.97969 15 7.5 14.5203 7.5 13.9286C7.5 13.0844 7.33372 12.2484 7.01065 11.4685C6.68759 10.6885 6.21406 9.97983 5.61712 9.38288C5.02017 8.78594 4.31149 8.31241 3.53154 7.98935C2.75159 7.66628 1.91564 7.5 1.07143 7.5C0.479695 7.5 0 7.0203 0 6.42857Z" fill="url(#paint0_radial_25772_11639)" fill-rule="evenodd"></path>
                  <path clip-rule="evenodd" d="M0 1.07143C0 0.479695 0.479695 0 1.07143 0C2.90055 0 4.71177 0.360273 6.40166 1.06025C8.09155 1.76023 9.62703 2.7862 10.9204 4.07958C12.2138 5.37297 13.2398 6.90845 13.9398 8.59834C14.6397 10.2882 15 12.0994 15 13.9286C15 14.5203 14.5203 15 13.9286 15C13.3368 15 12.8571 14.5203 12.8571 13.9286C12.8571 12.3808 12.5523 10.8483 11.96 9.41837C11.3677 7.98846 10.4996 6.68922 9.40519 5.59481C8.31078 4.50041 7.01153 3.63228 5.58163 3.03999C4.15172 2.4477 2.61915 2.14286 1.07143 2.14286C0.479695 2.14286 0 1.66316 0 1.07143Z" fill="url(#paint1_radial_25772_11639)" fill-rule="evenodd"></path>
                  <path d="M4.28571 12.8571C4.28571 14.0406 3.32632 15 2.14286 15C0.95939 15 0 14.0406 0 12.8571C0 11.6737 0.95939 10.7143 2.14286 10.7143C3.32632 10.7143 4.28571 11.6737 4.28571 12.8571Z" fill="url(#paint2_radial_25772_11639)"></path>
                  <defs>
                    <radialGradient id="paint0_radial_25772_11639" cx="0" cy="0" gradientTransform="translate(0 15) rotate(-41.1859) scale(17.0842)" gradientUnits="userSpaceOnUse" r="1">
                      <stop stop-color="#8CBE4C"></stop>
                      <stop offset="1" stop-color="#3B5020"></stop>
                    </radialGradient>
                    <radialGradient id="paint1_radial_25772_11639" cx="0" cy="0" gradientTransform="translate(0 15) rotate(-41.1859) scale(17.0842)" gradientUnits="userSpaceOnUse" r="1">
                      <stop stop-color="#8CBE4C"></stop>
                      <stop offset="1" stop-color="#3B5020"></stop>
                    </radialGradient>
                    <radialGradient id="paint2_radial_25772_11639" cx="0" cy="0" gradientTransform="translate(0 15) rotate(-41.1859) scale(17.0842)" gradientUnits="userSpaceOnUse" r="1">
                      <stop stop-color="#8CBE4C"></stop>
                      <stop offset="1" stop-color="#3B5020"></stop>
                    </radialGradient>
                  </defs>
                </svg>
                <!-- <el-avatar icon="el-icon-user-solid" :size="20"></el-avatar> -->
                <div class="name">{{ loginInfo.online_num }}</div>
              </div>
              <div class="top-right flex flex-ac" v-if="!$store.state.loginState">
                <div class="btn" @click="handleShowReg">注册</div>
                <div class="btn btn1" @click="goLogin">登录</div>
              </div>
              <div class="top-right1 flex flex-ac" v-else>
                <div class="mess" @click="goCharge">
                  <div class="mess-right flex flex-ac">
                    <div>
                      <div class="mess-span2 flex flex-ac">
                        <img src="@/assets/images/money.png" class="money-img" />
                        <strong>{{ Number($store.state.money).toFixed(2) }}</strong>
                      </div>
                      <div class="mess-span2 flex flex-ac">
                        <img src="@/assets/images/masonry.png" class="masonry-img" />
                        <strong>{{ $store.state.masonry }}</strong>
                      </div>
                    </div>
                    <div class="">
                      <img src="@/assets/images/add.png" class="masonry-add-img" style="width: 20px;height: auto;margin-left: 10px;" />
                    </div>
                    <!-- <div class="btn-yellow">充值</div> -->
                  </div>
                </div>
                <div class="nav-itme flex flex-ac" @click="goPage('this','/me/inform')">
                  <i class="iconfont icon-xx"></i>
                  <span v-if="loginInfo.message_notice_num&&loginInfo.message_notice_num!=0" class="label-p"></span>
                  <!-- <span v-if="loginInfo.message_notice_num&&loginInfo.message_notice_num!=0" class="label-n">{{ loginInfo.message_notice_num>99?'99+':loginInfo.message_notice_num }}</span> -->
                  <!-- <a href="/#/me/inform">消息</a> -->
                </div>
                <div class="top-right1-ico" @click="goPage('this','/personal')">
                  <img :src="$store.state.img?$store.state.img:'@/assets/images/header-img.png'" />
                  <span v-if="!showMenuState" class="p-1 name">{{ $store.state.name }}</span>
                  <!-- <i class="el-icon-arrow-down"></i> -->
                </div>
              </div>
            </el-col>
          </div>
        </el-row>
      </div>
    </div>
    <div class="bot">
      <router-view></router-view>
    </div>
    <!--注册盒子-->
    <div class="reg csgo-mask" v-if="regBox.regShow">
      <div class="reg-warp">
        <div class="btn-x" @click="hideReg">
          <img src="@/assets/images/btn-x.png" alt="" srcset="">
        </div>
        <div class="reg-sel">
          <span class="active-span">手机注册</span>
        </div>
        <div class="input" v-if="regBox.regType=='phone'">
          <el-input class="input1" v-model="regBox.phone" placeholder="手机号码"></el-input>
          <div class="input1-warp">
            <el-input class="input1" v-model="regBox.password" placeholder="设置密码" :type="regBox.isLook?'text':'password'"></el-input>
            <div class="getCode" @click="regBox.isLook=!regBox.isLook">
              <i class="iconfont" :class="[regBox.isLook?'icon-zhengyan':'icon-biyan']"></i>
            </div>
          </div>
          <div class="input1-warp">
            <el-input class="input1" v-model="regBox.captcha_code" placeholder="验证码"></el-input>
            <div class="getCode" @click="getphoneCode('reg')" :disabled="!regBox.phonecodeState">
              <i v-if="regBox.loadingReg" class="el-icon-loading"></i>
              {{ regBox.phonecodeState ? "获取验证码" : regBox.phonecodeTime + " s" }}
            </div>
          </div>
          <el-input class="input1" v-model="regBox.invite_code" placeholder="邀请码（没有可以不填）"></el-input>
        </div>
        <div class="btn-w-r-bg" @click="regBtn">
          <div class="btn-c-r">注册</div>
        </div>
        <div class="reg-deal">
          <el-checkbox v-model="regBox.ageCheck"></el-checkbox>
          <span style="margin-left: 10px;" @click="regBox.ageCheck=!regBox.ageCheck">本人已年满18周岁</span>
        </div>
        <div class="reg-deal">
          <el-checkbox v-model="regBox.aggreeCheck"></el-checkbox>
          <span @click="regBox.aggreeCheck=!regBox.aggreeCheck" style="margin-left: 10px;">我已经阅读并接受本站的
            <strong @click.stop="regGo('UserAgreement')">用户协议</strong>和
            <strong @click.stop="regGo('Privacy')">隐私条款</strong>。</span>
        </div>
        <div class="go-login" @click="goLogin">已有账号?点击登录>></div>
      </div>
    </div>
    <!--登录盒子-->
    <div class="login csgo-mask" v-if="loginOpen">
      <div class="reg-warp">
        <div class="btn-x" @click="hideLogin">
          <img src="@/assets/images/btn-x.png" alt="" srcset="">
        </div>
        <div class="reg-sel" style="justify-content: center;">
          <span :class="{'active-span':regBox.loginType=='password'}" @click="regBox.loginType='password'">密码登录</span>
          <span :class="{'active-span':regBox.loginType=='code'}" @click="regBox.loginType='code'">验证码登录</span>
        </div>
        <div class="input">
          <el-input class="input1" v-model="regBox.phone" placeholder="手机号码或邮箱"></el-input>
          <div v-if="regBox.loginType=='password'" class="input1-warp">
            <el-input class="input1" v-model="regBox.password" placeholder="密码" :type="regBox.isLook?'text':'password'"></el-input>
            <div class="getCode" @click="regBox.isLook=!regBox.isLook">
              <i class="iconfont" :class="[regBox.isLook?'icon-zhengyan':'icon-biyan']"></i>
            </div>
          </div>
          <div v-else class="input1-warp">
            <el-input class="input1" v-model="regBox.captcha_code" placeholder="验证码"></el-input>
            <div class="getCode" @click="getphoneCode('login')" :disabled="!regBox.phonecodeState">
              <i v-if="regBox.loadingReg" class="el-icon-loading"></i>
              {{ regBox.phonecodeState ? "获取验证码" : regBox.phonecodeTime + " s" }}
            </div>
          </div>
        </div>
        <div class="login-pass">
          <!-- <el-checkbox class="login-pass1" v-model="regBox.loginChecked">记住登录</el-checkbox> -->
          <span></span>
          <span @click="goRegForget('forgetBox')">忘记密码</span>
        </div>
        <div class="reg-deal">
          <el-checkbox v-model="regBox.ageCheck"></el-checkbox>
          <span style="margin-left: 10px;" @click="regBox.ageCheck=!regBox.ageCheck">本人已年满18周岁</span>
        </div>
        <div class="reg-deal">
          <el-checkbox v-model="regBox.aggreeCheck"></el-checkbox>
          <span @click="regBox.aggreeCheck=!regBox.aggreeCheck" style="margin-left: 10px;">我已经阅读并接受本站的
            <strong @click.stop="regGo('UserAgreement')">用户协议</strong>和
            <strong @click.stop="regGo('Privacy')">隐私条款</strong>。</span>
        </div>
        <div class="btn-w-r-bg" @click="getLogin">
          <div class="btn-c-r">登录</div>
        </div>
        <div class="go-login" @click="goRegForget('regShow')">还没有账号？点击注册</div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <div class="reg csgo-mask" v-if="regBox.forgetBox">
      <div class="reg-warp">
        <div class="btn-x" @click="hideReg">
          <img src="@/assets/images/btn-x.png" alt="" srcset="">
        </div>
        <div class="reg-sel">
          <span class="active-span">忘记密码</span>
        </div>
        <div class="input">
          <el-input class="input1" v-model="regBox.phone" placeholder="手机号码"></el-input>
          <div class="input1-warp">
            <el-input class="input1" v-model="regBox.password" placeholder="设置密码" :type="regBox.isLook?'text':'password'"></el-input>
            <div class="getCode" @click="regBox.isLook=!regBox.isLook">
              <i class="iconfont" :class="[regBox.isLook?'icon-zhengyan':'icon-biyan']"></i>
            </div>
          </div>
          <div class="input1-warp">
            <el-input class="input1" v-model="regBox.againpassword" placeholder="再次输入密码" :type="regBox.isLookA?'text':'password'"></el-input>
            <div class="getCode" @click="regBox.isLookA=!regBox.isLookA">
              <i class="iconfont" :class="[regBox.isLookA?'icon-zhengyan':'icon-biyan']"></i>
            </div>
          </div>
          <div class="input1-warp">
            <el-input class="input1" v-model="regBox.captcha_code" placeholder="验证码"></el-input>
            <div class="getCode" @click="getphoneCode('forget')" :disabled="!regBox.phonecodeState">
              <i v-if="regBox.loadingReg" class="el-icon-loading"></i>
              {{ regBox.phonecodeState ? "获取验证码" : regBox.phonecodeTime + " s" }}
            </div>
          </div>
        </div>
        <div class="btn-w-r-bg" @click="reset">
          <div class="btn-c-r">重置密码</div>
        </div>
        <div class="go-login" @click="goLogin">想起密码了>></div>
      </div>
    </div>
    <!--登录完成右边导航-->
    <el-drawer :visible.sync="drawer" direction="rtl" :before-close="handleClose" size="250px" class="sty">
      <div class="sty-btn">
        <span @click="goPage('this','/shoping')">商城</span>
        <span @click="goCharge">充值</span>
      </div>
      <div class="sty-menu">
        <el-menu class="el-menu-vertical-demo" text-color="#fff" @select="(key)=>goPage('this',key)">
          <el-menu-item index="/me/bill">
            <i class="el-icon-s-order"></i>
            <span slot="title">我的账单</span>
          </el-menu-item>
          <el-menu-item index="/me/spread" v-if="$store.state.userInfo && $store.state.userInfo.invite_open == 1">
            <i class="el-icon-s-promotion"></i>
            <span slot="title">活动推广</span>
          </el-menu-item>
          <el-menu-item index="/me/me">
            <i class="el-icon-s-custom"></i>
            <span slot="title">个人中心</span>
          </el-menu-item>
          <el-menu-item index="/me/inform">
            <i class="el-icon-message-solid"></i>
            <span slot="title">消息通知</span>
          </el-menu-item>
          <el-menu-item index="/me/retrieve">
            <i class="el-icon-message-solid"></i>
            <span slot="title">取回列表</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="sty-next" @click="nextLogin">退出登录</div>
    </el-drawer>
    <!-- 红包 -->
    <hongbao ref="hongbao" />
    <!-- 新人专属盒子 -->
    <div v-if="showSin" class="new-people-box flex flex-ac flex-jc">
      <div class="popupContent">
        <span class="people-x" @click="showSin=false">
          <i class="el-icon-circle-close"></i>
        </span>
        <img src="@/assets/images/board/2026-05-20.jpg" @click="goSigin" />
        <!--        <div class="_btn" @click="goSigin"> 立即注册 </div>-->
      </div>
    </div>
    <RulePopup ref="RulePopup" @onClose="regBox.aggreeCheck=true" />
    <PopPayment />
    <PopPersonal ref="pop-personal" />
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { setToken, getToken } from '@/api/auth'
import RulePopup from "@/components/rule-popup.vue"
import hongbao from "@/g-components/hongbao.vue"
import PopPayment from "@/g-components/pop-payment.vue"
import PopPersonal from "@/views/me/pop-personal.vue"
import { mapGetters } from 'vuex'

export default {
  name: "Home",
  components: { hongbao, RulePopup, PopPayment, PopPersonal },
  directives: { Clickoutside },
  data() {
    return {
      menu: [{
        id: 1,
        iconfont: 'icon-fasongx',
        selState: false,
        path: "/index",
        child: ["/index", "/index/Openbox"],
        value: '箱子大厅'
      }, {
        id: 2,
        iconfont: 'icon-battle',
        selState: false,
        path: "/fight",
        child: ["/fight", "/fight/room", "/fight/rule", "/fight/history"],
        value: '逐鹿之战'
      },
      {
        id: 2,
        iconfont: 'icon-fangzi',
        selState: false,
        path: "/roll",
        child: ["/roll", "/roll/room"],
        value: 'ROLL房'
      },
      //   {
      //   id: 3,
      //   iconfont: 'icon-lucky_right',
      //   selState: false,
      //   path: "/lucky",
      //   child: ["/lucky", "/lucky/open", "/lucky/history"],
      //   value: '幸运饰品'
      // },
      {
        id: 4,
        iconfont: 'icon-lucky_right',
        selState: false,
        path: "/upgrade",
        child: ["/upgrade"],
        value: '升级饰品'
      }, {
        id: 5,
        iconfont: 'icon-shangcheng-copy',
        selState: false,
        path: "/shoping",
        child: ["/shoping"],
        value: '饰品商城'
      }, {
        id: 6,
        iconfont: 'icon-package',
        selState: false,
        path: "/personal",
        child: ["/personal"],
        value: '饰品背包'
      }, {
        id: 7,
        selState: false,
        path: "/index/task-center",
        child: ['/index/task-center'],
        value: '每日福利'
      }],
      loginInfo: {
        player_num: 0,
        online_num: 0,
        openbox_num: 0,
        message_notice_num: 0
      },
      name: "CS:GO盲盒",
      regBox: {
        regType: 'phone',
        loginType: 'password',
        regShow: false,
        ageCheck: false,
        aggreeCheck: false,
        phonecodeState: true,
        loadingReg: false,
        phonecodeTime: 60,
        phone: '',
        password: '',
        againpassword: '',
        captcha_code: '',
        invite_code: '',
        loginChecked: false, //登录
        forgetBox: false,  // 忘记密码
        // 密码是否可以查看
        isLook: false,
        isLookA: false
      },
      phonetimer: null,
      loginfalse: true, //登录状态
      windowWidth: document.body.clientWidth,

      hongbaoData: [],
      my_hongbao: "",
      hongbaoid: "",
      quhuiSize: "680px",
      showMenuState: false,
      loading: false,
      me: {},
      drawer: false, //右侧导航状态
      showNav: true,
      code: '',
      loging: '',
      showSin: false
    };
  },
  computed: {
    ...mapGetters([
      'loginOpen', 'personalOpen'
    ])
  },
  watch: {
    //监听路由
    $route(to, from) {
      var path = to.path
      for (let i = 0; i < this.menu.length; i++) {
        if (this.menu[i].child.includes(path)) {
          this.menu[i].selState = true;
        } else {
          this.menu[i].selState = false;
        }
      }
      document.documentElement.scrollTop = 0
    },
    loginOpen(newVal) {
      if (newVal) {
        this.showSin = false
      }
    },
    personalOpen(newVal) {
      if (newVal) {
        this.$refs['pop-personal'].toggle(newVal)
      }
    }
  },
  created() {
    let path = this.$route.path
    for (let i = 0; i < this.menu.length; i++) {
      if (this.menu[i].child.includes(path)) {
        this.menu[i].selState = true;
      } else {
        this.menu[i].selState = false;
      }
    }
    this.showSin = this.loginOpen ? false : getToken() == ''
    this.getData()
    setInterval(() => {
      this.getData()
    }, 1000 * 5)
  },
  mounted() {
    let codeInfo = this.GetUrlParam('code')
    this.regBox.invite_code = codeInfo ? codeInfo.split("#")[0] : '';
    //判断屏幕宽度
    const that = this
    window.addEventListener('resize', function () {
      that.handleResize()
    })
    this.handleResize()
  },
  methods: {
    getData() {
      this.$doGet('/api/hall.General/loginInfo').then((res) => {
        this.loginInfo = res.data
      }).catch(() => { })
    },
    handleResize() {
      if (document.body.clientWidth < 1200) {
        this.quhuiSize = "100%";
        this.showMenuState = true;
        this.showNav = false;
      } else {
        this.quhuiSize = "680px";
        this.showMenuState = false;
        this.showNav = true;
      }
      console.log('this.showNav', this.showNav)
    },
    // 新用户 点击立即注册按钮
    goSigin() {
      this.showSin = false
      this.handleShowReg()
    },
    goCharge() {
      this.$store.commit("setPaymentOpen", true)
    },
    // 登录注册方法
    regBtn() {
      if (this.regBox.phone == '') {
        this.$message.warning('请先输入手机号码!')
        return false
      }
      if (this.regBox.password == '') {
        this.$message.warning('请先输入密码!')
        return false
      }
      if (this.regBox.captcha_code == '') {
        this.$message.warning('请先输入验证码!')
        return false
      }
      if (!this.regBox.ageCheck) {
        this.$message.warning('请先确认本人是否已年满18周岁!')
        return false
      }
      if (!this.regBox.aggreeCheck) {
        this.$message.warning('请先确认我已经阅读并接受本站的用户协议和隐私条款！')
        return false
      }
      this.$doPost("/api/member.Register/phoneRegister", {
        phone: this.regBox.phone,
        password: this.regBox.password,
        invite_code: this.regBox.invite_code,
        captcha_code: this.regBox.captcha_code,
        platform: 10,
        application: 13
      }).then((res) => {
        this.$message.success('注册成功，请登录！')
        this.goLogin()
      }).catch(() => { })
    },
    //获取验证码
    getphoneCode(type) {
      let url = ''
      if (this.regBox.phone == '') {
        this.$message.warning('请先输入手机号码!')
        return false
      }
      if (type == 'reg') {
        url = '/api/member.Register/phoneCaptcha'
      }
      if (type == 'login') {
        url = '/api/member.Login/phoneCaptcha'
      }
      if (type == 'forget') {
        url = '/api/member.Forget/phoneCaptcha'
      }
      this.regBox.loadingReg = true
      this.$doGet(url, { phone: this.regBox.phone }).then((res) => {
        this.$message.success(res.msg)
        this.regBox.loadingReg = false
        this.regBox.phonecodeState = false
        if (this.phonetimer) {
          clearInterval(this.phonetimer)
        }
        this.regBox.phonecodeTime = 60
        this.phonetimer = setInterval(() => {
          if (this.regBox.phonecodeTime == 0) {
            this.regBox.phonecodeState = true
            this.regBox.phonecodeTime = 60
            clearInterval(this.phonetimer)
          } else {
            this.regBox.phonecodeTime--
          }
        }, 1000)
      }).catch(() => {
      })
    },
    hideReg() {
      this.regBox.regShow = false
      this.regBox.forgetBox = false
      this.regBox.isLook = false
      this.regBox.isLookA = false
      if (this.phonetimer) {
        clearInterval(this.phonetimer)
      }
      this.regBox.phone = ''
      this.regBox.password = ''
      this.regBox.captcha_code = ''
      this.regBox.phonecodeState = true
      this.regBox.phonecodeTime = 60
    },
    regGo(url) {
      // this.regBox.regShow = false
      this.$refs['RulePopup'].toggle(url)
      // this.$router.push({
      //   path: url
      // });
    },
    handleShowReg() {
      let path = this.$route.path
      if (path == '/other/agreement' || path == '/other/privacy') {
        this.$router.push({
          path: '/index'
        })
      }
      this.regBox.regShow = true
    },
    //点开登录 注册盒子 显示登录
    goLogin() {
      this.hideReg()
      this.$store.commit("getLogin", true)
    },
    //隐藏登录框
    hideLogin() {
      this.$store.commit("getLogin", false);
    },
    goRegForget(name) {
      this.$store.commit("getLogin", false)
      this.regBox[name] = true
    },
    // 登录注册结束
    clickOut() {
      if (this.windowWidth < 1024) {
        this.showNav = false;
      }
    },
    //登录按钮
    getLogin() {
      if (this.regBox.phone == '') {
        this.$message.warning('请先输入手机号码!')
        return false
      }
      this.loging = 'loging'
      let parms = {
        account: this.regBox.phone,
        acc_type: 'phone',
        platform: 10,
        application: 13
      }
      if (this.regBox.loginType == 'password') {
        if (this.regBox.password == '') {
          this.$message.warning('请先输入密码!')
          return false
        }
        parms.password = this.regBox.password
        parms.captcha_id = ''
        parms.captcha_code = ''
      } else {
        if (this.regBox.captcha_code == '') {
          this.$message.warning('请先输入验证码!')
          return false
        }
        parms.phone = this.regBox.phone
        parms.captcha_code = this.regBox.captcha_code
      }
      if (!this.regBox.ageCheck) {
        this.$message.warning('请先确认本人是否已年满18周岁!')
        return false
      }
      if (!this.regBox.aggreeCheck) {
        this.$message.warning('请先确认我已经阅读并接受本站的用户协议和隐私条款！')
        return false
      }
      this.$doPost(this.regBox.loginType == 'password' ? "/api/member.Login/login" : '/api/member.Login/phoneLogin', parms).then((res) => {
        setToken(res.data.ApiToken, 7)
        this.showSin = false
        location.reload()
        this.getInfo()
      }).catch(() => {
        this.loging = ''
      })
    },
    async getInfo() {
      await this.$store.dispatch('getInfo')
      this.hideLogin()
      this.loging = ''
    },
    //退出登录
    async nextLogin() {
      await this.$store.dispatch('logout')
      this.drawer = false
      this.$router.push({
        path: `/Index`,
      });
    },
    //左侧导航
    goMenu(id, path) {
      if (this.windowWidth < 1024) {
        this.showNav = !this.showNav;
      }
      // if (id == 6) {
      //   this.gopath('Dota');
      // } else if (id == 7) {
      //   this.gopath('Payment');
      // }
      for (let i = 0; i < this.menu.length; i++) {
        if (id == this.menu[i].id) {
          this.menu[i].selState = true
        } else {
          this.menu[i].selState = false
        }
      }
      this.$router.push({
        path: `${path}`,
      });
    },
    goPage(type, url) {
      console.log(url)
      this.drawer = false
      if (type == 'window') {
        window.open("https://jq.qq.com/?_wv=1027&k=TB3n4StY");
      } else if (type == 'hongbao') {
        this.$refs['hongbao'].openHongbao()
      } else if (type == 'window_other') {
        window.open(url, "_blank");
      } else {
        this.$router.push(url);
      }
    },
    //菜单路径跳转
    gopath(key) {
      if (this.$store.state.id) {
        this.$router.push({
          path: `/${key}`,
        });
      } else {
        this.$store.commit("getLogin", true);
      }
    },
    // 忘记密码
    reset() {
      if (this.regBox.phone == '') {
        this.$message.warning('请先输入手机号码!')
        return false
      }
      if (this.regBox.password == '') {
        this.$message.warning('请先输入密码!')
        return false
      }
      if (this.regBox.againpassword == '') {
        this.$message.warning('请再次输入密码!')
        return false
      }
      if (this.regBox.againpassword != this.regBox.password) {
        this.$message.warning('两次密码不一致请重新输入!')
        return false
      }
      if (this.regBox.captcha_code == '') {
        this.$message.warning('请先输入验证码!')
        return false
      }
      this.$doPost("/api/member.Forget/phoneForget", {
        phone: this.regBox.phone,
        password: this.regBox.password,
        captcha_code: this.regBox.captcha_code,
        platform: 10,
        application: 13
      }).then((res) => {
        this.$message.success(res.msg)
        this.goLogin()
      }).catch(() => { })
    },
    // 获取参数
    GetUrlParam(name) {
      var url = window.location.href;
      let params = url.substr(url.lastIndexOf("?") + 1).split("&");
      for (let i = 0; i < params.length; i++) {
        let param = params[i];
        let key = param.split("=")[0];
        let value = param.split("=")[1];
        if (key === name) {
          return value;
        }
      }
    },
    //右侧导航关闭
    handleClose(done) {
      done();
    },
  },
};
</script>
<style lang="less" scoped>
// 顶部nav固定的样式
.home {
  min-height: 100vh;
  // background-color: #20222b;
  .top {
    height: 72px;
    color: #fff;
    position: fixed;
    top: 0;
    z-index: 30;
    width: 100%;
    .nav-itme {
      cursor: pointer;
      position: relative;
      line-height: 72px;
      padding: 0 20px 0 6px;
      a {
        margin-left: 5px;
      }
      .label-n {
        position: absolute;
        top: 6px;
        right: 20px;
        background: red;
        line-height: 20px;
        font-size: 12px;
        border-radius: 20px;
        padding: 0 6px;
      }
      .label-p {
        position: absolute;
        width: 10px;
        height: 10px;
        top: 25px;
        right: 15px;
        background: red;
        border-radius: 50%;
      }
    }
    .top-el-row {
      background: #000;
      padding: 0 30px;
      box-sizing: border-box;
      // background-image: url(~@/assets/images/nav-bg.png);
      background-size: 100% 100%;
      .top-l-r {
        width: 100%;
        height: 100%;
      }
      .logo {
        width: calc(100% - 250px);
        .img1 {
          height: 55px;
          width: auto;
          cursor: pointer;
        }
        .logo-mobile {
          display: none;
        }
        .logo-pad {
          display: none;
        }
        .yidong-menu {
          display: none;
        }
        .logo-word {
          font-size: 24px;
          font-weight: bold;
          //font-style: italic;
          color: #ffc400;
          //text-shadow: 0 0 5px #ffc400, 1px 1px 1px #ffc400, -1px -1px 1px #ffc400, 0 0 10px #ffc400, 0 0 20px #ffc400;
        }
      }
      .base-header {
        margin-left: 40px;
        .nav2 {
          line-height: 72px;
          ul {
            display: flex;
            li {
              padding: 0 10px;
              cursor: pointer;
              color: #fff;
              font-size: 15px;
              white-space: nowrap;
              letter-spacing: 2px;
              padding: 0 20px;
              position: relative;
              &.active {
                background: #ffc400;
                font-weight: 700;
                color: #fff !important;
                // &::after {
                //   content: "";
                //   width: calc(100% - 52px);
                //   height: 2px;
                //   position: absolute;
                //   bottom: 16px;
                //   left: 26px;
                //   background: #ffffff;
                // }
              }
              &:hover {
                color: #ffc400;
              }
            }
          }
        }
      }
      // 登录注册
      .top-name {
        height: 72px;
        justify-content: flex-end;
        .top-right {
          align-items: self-end;
          .btn {
            white-space: nowrap;
            margin-left: 5px;
            line-height: 34px;
            padding: 0px 25px;
            font-size: 15px;
            font-weight: 700;
            color: #ffc400;
            border: 1px solid #ffc400;
            cursor: pointer;
            &.btn1 {
              color: #20212b;
              background: #ffc400;
            }
          }
        }
        .top-right1 {
          // align-items: self-end;
          cursor: pointer;
          .mess {
            .mess-right {
              .mess-span2 {
                // padding-left: 24px;
                img {
                  margin-right: 6px;
                }
                strong {
                  font-size: 14px;
                  color: #ffc400;
                }
              }
            }
          }
          .btn-yellow {
            font-weight: bold;
            margin-left: 24px;
            -webkit-animation-name: scaleDraw; /*关键帧名称*/
            -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
            -webkit-animation-iteration-count: infinite; /*动画播放的次数*/
            -webkit-animation-duration: 3s; /*动画所花费的时间*/
          }
          .top-right1-ico {
            // margin-left: 15px;
            line-height: 26px;
            display: flex;
            align-items: center;
            img {
              width: 20px;
              border-radius: 50%;
              height: 20px;
            }
            .name {
              font-size: 12px;
              margin-left: 10px;
              white-space: nowrap;
            }
          }
        }
        .p-r {
          color: #848492;
          // justify-content: flex-start;
          .logo-span {
            cursor: pointer;
            display: flex;
            height: 17px;
          }
          .logo-span:hover {
            .text {
              color: #e9b10e;
            }
          }

          .top-pay:nth-child(2) {
            // margin-left: 12px;
          }
          .span,
          .pay-span {
            font-size: 14px;
            margin-left: 6px;
            white-space: nowrap;
          }
          .pay-span {
            margin-left: 10px;
            color: #1a1c24;
            display: inline-block;
            padding: 0 10px;
            font-size: 14px;
            border-radius: 5px;
            background-color: #02bf4d;
            position: relative;
          }
          .pay-span::after {
            top: 50%;
            left: -4px;
            color: #02bf4d;
            width: 0;
            content: '';
            position: absolute;
            border-top: 4px solid transparent;
            margin-top: -4px;
            border-right: 4px solid;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }
  }
  .bot {
    // height: calc(100vh - 120px);
    box-sizing: border-box;
  }
}
.new-people-box {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.6);
  .popupContent {
    position: relative;
    // width: 800px;
    max-width: 460px;
    box-sizing: border-box;
    flex-direction: column;
    padding: 30px;
    box-sizing: border-box;
    .people-x {
      position: absolute;
      right: 30px;
      top: 0;
      color: #fff;
      font-size: 30px;
      cursor: pointer;
      padding: 30px;
    }
    ._btn {
      background: linear-gradient(
          140deg,
          hsla(0, 0%, 100%, 0),
          hsla(0, 0%, 100%, 0.8) 80%,
          hsla(0, 0%, 100%, 0)
        ),
        #fdb01c;
      color: #21214a;
      line-height: 45px;
      width: 200px;
      margin: 20px auto 0;
      border-radius: 0.19rem;
      text-align: center;
      cursor: pointer;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
}
//右侧导航

.sty {
  .sty-menu {
    height: 100%;
    background-color: #30313f;
  }
  .sty-btn {
    padding: 8px;
    background-color: #1f1f26;
    display: flex;
    justify-content: space-between;
    span {
      color: #1a1c24;
      font-size: 14px;
      font-weight: 600;
      width: 100px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
    }
    span:hover {
      cursor: pointer;
    }
    span:first-child:hover {
      background-color: #15bcf8;
    }
    span:first-child {
      background-color: #17b4ede7;
    }
    span:last-child {
      background-color: #f1b80a;
    }
    span:last-child:hover {
      background-color: #e9b20ee3;
    }
  }
  .sty-next {
    position: absolute;
    bottom: 0;
    background-color: #24252f;
    width: 100%;
    padding: 12px 0;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: #848492;
    cursor: pointer;
  }
  .sty-next:hover {
    background-color: #313242;
    color: #a6a6b9;
  }
}
/deep/ .el-menu {
  border-right: none;
  background: transparent;
}
/deep/.el-menu-item {
  padding: 0 40px;
}
/deep/.el-menu-item:hover {
  background-color: #24252f;
}
/deep/ .el-drawer__header {
  display: none;
}
/deep/ .el-drawer__body {
  background-color: #30313f;
}
</style>

<style lang="less">
.right-bar {
  top: 50%;
  right: 0px;
  z-index: 1200;
  position: fixed;
  background: #000;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.4);
  // background-color: #30313f;
  background-color: #fff;
  padding: 10px 0;
  border-radius: 1px;
}
.bar-show {
  width: 60px;
  transition: width 0.7s ease-out;
  min-height: 180px;
}
.bar-hidden {
  width: 0;
  transition: width 0.7s ease-out;
  min-height: 180px;
}
</style>

<style scoped>
.ripple {
  position: relative;
  /* //隐藏溢出的径向渐变背景 */
  overflow: hidden;
  /* width: 200;
    height: 100; */
}

.ripple:after {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  /* //设置径向渐变 */
  background-image: radial-gradient(circle, #666 15%, transparent 15.01%);
  background-repeat: no-repeat;
  background-position: 50%;
  transform: scale(15, 15);
  opacity: 0;
  transition: transform 0.8s, opacity 0.8s;
}

.ripple:active:after {
  transform: scale(0, 0);
  opacity: 0.6;
  /* //设置初始状态 */
  transition: 0s;
}
.loging {
  background-color: #808080 !important;
}
</style>
<style>
.WifiIcon_wifi_TvIYK path {
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-direction: reverse;
}
.WifiIcon_wifi_TvIYK path:first-child {
  animation-name: WifiIcon_animate-arrow1_zpub5;
}
.WifiIcon_wifi_TvIYK path:nth-child(2) {
  animation-name: WifiIcon_animate-arrow2_S2HPg;
}
.WifiIcon_wifi_TvIYK path:nth-child(3) {
  animation-name: WifiIcon_animate-arrow3_Vf6lV;
}
/* 动画 */
@keyframes WifiIcon_animate-arrow1_zpub5 {
  0% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.5;
  }
  75% {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
}
@keyframes WifiIcon_animate-arrow2_S2HPg {
  0% {
    opacity: 0.5;
  }
  30% {
    opacity: 0.5;
  }
  60% {
    opacity: 1;
  }
  90% {
    opacity: 0.5;
  }
  to {
    opacity: 0.5;
  }
}
@keyframes WifiIcon_animate-arrow3_Vf6lV {
  0% {
    opacity: 0.5;
  }
  35% {
    opacity: 1;
  }
  70% {
    opacity: 0.5;
  }
}
@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
  0% {
    font-size: 12px;
  }
  25% {
    font-size: 14px;
  }
  50% {
    font-size: 12px;
  }
  75% {
    font-size: 14px;
  }
}
</style>
